// Which pairing a record was taken under, and whether it may still be sent.
//
// Its own file, and plain functions with nothing around them, because this is the rule
// that decides whether one partner's badge can become another partner's lead. A rule
// that important has to be testable without a database or a framework behind it.

// Records taken before the app tracked pairings, and the value the database upgrade
// stamps them with. A phone already paired when the update lands adopts the same value,
// so a shift already under way keeps uploading.
export const LEGACY_PAIRING = 'legacy'

/**
 * Whether a record may be sent under the key the phone holds now.
 *
 * A phone with no pairing sends nothing. That covers the gap between a phone being
 * deactivated and being set up again, where the records are real but there is nobody
 * they can honestly be sent as.
 */
export const mayUpload = (scan: { pairing: string }, pairing: string): boolean =>
  !!pairing && scan.pairing === pairing
